
  <template>
    <input v-bind:type="type" class="form-control" :value="value"
           @input="input"
           v-on="listeners" />
  </template>

<script>

  var errors = [];

	export default {
    name: 'testcomponent',
		components: {
    },
    props: {
      value: {
        type: String,
        default: "Select file"
      },
      type: {
        type: String,
        default: "text"
      }
    },
    created() {
      
    },
    mounted() {
     
    },
    methods: {
      input(event) {
        this.errors = this.validateinput(event.target.value);
        this.$emit('validationerror', this.errors);
        this.$emit('input', event.target.value);
      },
      validateinput(val) {
        var errors = [];
        if (this.type == "url") {
          if (val != "" && !val.startsWith("http")) {
            errors.push("should start with http://");
          }
        }
        return errors;
      }
    },
    data() {
      return {
        errors
      }
    },
    computed: {
      listeners() {
        const { input, ...listeners } = this.$listeners;
        return listeners;
      },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/form-components/input-text.vue